const DB_NAME = 'xmanage-cache';
const DB_VERSION = 1;
const STORE_NAME = 'dashboard';

function openDB(): Promise<IDBDatabase> {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

export async function cacheGet<T>(key: string): Promise<T | null> {
  try {
    const db = await openDB();
    return new Promise((resolve) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(key);
      req.onsuccess = () => {
        const entry = req.result;
        if (!entry) return resolve(null);
        resolve(entry.data as T);
      };
      req.onerror = () => resolve(null);
    });
  } catch {
    return null;
  }
}

export async function cacheSet<T>(key: string, data: T): Promise<void> {
  try {
    const db = await openDB();
    return new Promise((resolve) => {
      const tx = db.transaction(STORE_NAME, 'readwrite');
      const store = tx.objectStore(STORE_NAME);
      store.put({ data, timestamp: Date.now() }, key);
      tx.oncomplete = () => resolve();
      tx.onerror = () => resolve();
    });
  } catch {
    // silent fail
  }
}

export async function cacheGetTimestamp(key: string): Promise<number | null> {
  try {
    const db = await openDB();
    return new Promise((resolve) => {
      const tx = db.transaction(STORE_NAME, 'readonly');
      const store = tx.objectStore(STORE_NAME);
      const req = store.get(key);
      req.onsuccess = () => {
        const entry = req.result;
        resolve(entry?.timestamp ?? null);
      };
      req.onerror = () => resolve(null);
    });
  } catch {
    return null;
  }
}

export function buildCacheKey(businessId: string, year: number, month: number): string {
  return `dashboard_${businessId}_${year}_${month}`;
}

export interface CachedDashboardData {
  totalGross: number;
  totalStripeFees: number;
  totalRefunds: number;
  totalPaymentsUSD: number;
  paymentsCount: number;
  totalExpensesMVR: number;
  bankRate: number;
  creditCardRate: number;
  blackMarketRate: number;
  avgTransactionSize: number;
  debitGross: number;
  debitCount: number;
  creditGross: number;
  creditCount: number;
  dailyBalances: any[];
  transactions: any[];
  payouts: any[];
}
